<template>
    <div class="checker-default-layout" :verticalCenteredContent="true">
        <checker-page-header slot="header" />
        <div class="checker-default-layout__content">
            <slot></slot>
        </div>
        <checker-page-footer slot="footer" />
    </div>
</template>

<script>
import CheckerPageHeader from "@/components/page/CheckerPageHeader.vue";
import CheckerPageFooter from "@/components/page/CheckerPageFooter.vue";

export default {
    name: "CheckerDefaultLayout",
    components: {
        CheckerPageHeader,
        CheckerPageFooter,
    },
}
</script>

<style scoped lang="scss">
.checker-default-layout {
    background-color: $color-white;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.checker-default-layout__content {
    display: flex;
    justify-content: center;
    padding-top: rem(80);
    padding-left: 13%;
    padding-right: 13%;
}
</style>